import React from 'react';

function Header() {
    return <div>
        <header>
            <h1 className='heading'>Emoji Nation</h1>
        </header>
    </div>;
}

export default Header;